<div class="row">
  <div class="col-md-12">

    <nb-card>
      <nb-card-header *ngIf="czyKlientOptima()">{{'tytul.przychody-koszty-podatkowe' | translate}}</nb-card-header>
      <nb-card-header *ngIf="!czyKlientOptima() && wyswietlanieKosztow">{{'tytul.przychody-koszty' | translate}}</nb-card-header>
      <nb-card-header *ngIf="!czyKlientOptima() && !wyswietlanieKosztow">{{'tytul.przychody' | translate}}</nb-card-header>
      <nb-card-body>
        <section >
          <span>{{ 'akcja.wybierz-okres' | translate }}:</span>
        </section>
        <section class="mt-2 ml-3">
          <ngx-zakres-dat (zmianaZakresu)="onChangeZmianaZakresu($event)"></ngx-zakres-dat>
        </section>
      </nb-card-body>
    </nb-card>

    <nb-card>
      <nb-card-body>
        <ngx-przychody-koszty-wykres 
          [okresy]="okresy"
          [przychody]="przychody"
          [koszty]="koszty"         
        ></ngx-przychody-koszty-wykres>
      </nb-card-body>
    </nb-card>

    <nb-card>
      <nb-card-body>
        <ngx-przychody-koszty-tabela
          [dane]="przychodyKoszty"
          [zakresDat]="zakresDat"
          [wyswietlanieKosztow]="wyswietlanieKosztow"
        ></ngx-przychody-koszty-tabela>
      </nb-card-body>
    </nb-card>

    <nb-card *ngIf="materialy.length != 0">
      <nb-card-header>{{'tytul.materialy' | translate}}</nb-card-header>
      <nb-card-body>
        <ngx-materialy [dane]="materialy"></ngx-materialy>
      </nb-card-body>
    </nb-card>
    
  </div>
</div>